/**
 * 财务凭证模块翻译 - 中文
 * 包含：凭证定义、凭证生成、结转记录、科目对应
 */
export default {
  finance: {
    // ======== 凭证定义 voucherDef ========
    voucherDef: {
      title: '凭证定义',
      addVoucher: '新增凭证',
      editVoucher: '编辑凭证',
      name: '凭证名称',
      type: '凭证类别',
      typeJhd: '记帐凭证',
      typePhd: '付款凭证',
      erpType: 'ERP类型',
      erpTypeNc: '用友NC',
      erpTypeKingdee: '金蝶',
      erpTypeSap: 'SAP',
      status: '状态',
      statusEnabled: '启用',
      statusDisabled: '停用',
      hSql: '凭证头SQL',
      autoCast: '自动抛转',
      castDay: '抛转日',
      castHour: '抛转时间',
      groupField: '分组上传字段',
      illustration: '凭证说明',
      remark: '备注',
      // 操作
      search: '搜索',
      reset: '重置',
      // 消息
      fetchFailed: '获取凭证列表失败',
      addSuccess: '创建成功',
      editSuccess: '修改成功',
      deleteConfirm: '确定要删除凭证定义"{name}"吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      namePlaceholder: '请输入凭证名称',
      hSqlPlaceholder: '请输入凭证头SQL语句',
      illustrationPlaceholder: '请输入凭证说明',
      groupFieldPlaceholder: '留空则普通模式，填写辅助账编码按该字段拆分',
    },

    // ======== 凭证生成 voucherGenerate ========
    voucherGenerate: {
      title: '凭证生成',
      subtitle: '预览并生成凭证，上传至ERP',
      voucherTemplate: '凭证模板',
      voucherTemplatePlaceholder: '请选择凭证模板',
      voucherDate: '凭证日期',
      voucherDatePlaceholder: '请选择凭证日期',
      // 操作按钮
      preview: '预览',
      generate: '生成凭证',
      generateAndUpload: '生成并上传',
      downloadXml: '下载XML',
      uploadToErp: '上传至ERP',
      // 预览表格
      entryIndex: '序号',
      subjectCode: '科目编码',
      subjectName: '科目名称',
      summary: '摘要',
      debitAmount: '借方金额',
      creditAmount: '贷方金额',
      totalDebit: '借方合计',
      totalCredit: '贷方合计',
      // 确认对话框
      uploadConfirmTitle: '确认上传至ERP',
      uploadConfirmMsg: '即将上传凭证至ERP系统，借方合计：{debit}，贷方合计：{credit}，是否确认？',
      // 消息
      previewSuccess: '预览成功',
      previewFailed: '预览失败',
      generateSuccess: '凭证生成成功',
      generateFailed: '凭证生成失败',
      uploadSuccess: '上传成功',
      uploadFailed: '上传失败',
      noTemplate: '请先选择凭证模板',
      noDate: '请先选择凭证日期',
      duplicateWarning: '该凭证在所选日期已有结转记录，是否继续？',
    },

    // ======== 结转记录 voucherRecord ========
    voucherRecord: {
      title: '结转记录',
      subtitle: '查看凭证上传至ERP的记录',
      voucherName: '凭证名称',
      erpType: 'ERP类型',
      erpTypeNc: '用友NC',
      erpTypeKingdee: '金蝶',
      erpTypeSap: 'SAP',
      voucherDate: '凭证日期',
      dateRange: '日期范围',
      dateStart: '开始日期',
      dateEnd: '结束日期',
      status: '状态',
      statusSuccess: '成功',
      statusFailed: '失败',
      statusPreview: '预演',
      statusPartial: '部分成功',
      statusProcessing: '处理中',
      voucherNo: '凭证号',
      inputUser: '录入人',
      inputDate: '录入日期',
      errorMessage: '错误信息',
      // 操作
      viewDetail: '查看详情',
      reupload: '重新上传',
      reuploadConfirm: '确定要重新上传该凭证至ERP吗？',
      // 详情
      detailTitle: '结转记录详情',
      headerInfo: '凭证头信息',
      entryDetail: '分录明细',
      uploadDetail: '上传明细（分组）',
      groupValue: '分组值',
      itemCount: '分录行数',
      erpVoucherNo: 'ERP凭证号',
      // 消息
      fetchFailed: '获取结转记录失败',
      reuploadSuccess: '重新上传成功',
      reuploadFailed: '重新上传失败',
      detailFailed: '获取详情失败',
    },

    // ======== 科目对应 financeSubject ========
    financeSubject: {
      title: '科目对应',
      subtitle: '管理费用项与ERP科目映射',
      addSubject: '新增对应',
      editSubject: '编辑对应',
      feeItemName: '费用项名称',
      feeItemCode: '费用项编码',
      feeItemSelect: '请选择费用项',
      erpType: 'ERP类型',
      erpTypeNc: '用友NC',
      erpTypeKingdee: '金蝶',
      erpTypeSap: 'SAP',
      erpTypePlaceholder: '请选择ERP类型',
      subjectCode: '科目编码',
      subjectCodePlaceholder: '请输入科目编码',
      subjectName: '科目名称',
      subjectNamePlaceholder: '请输入科目名称',
      supplierName: '往来单位',
      supplierCode: '往来单位编码',
      channelName: '门店',
      signCompanyName: '收费主体',
      remark: '备注',
      // 消息
      fetchFailed: '获取科目列表失败',
      addSuccess: '创建成功',
      editSuccess: '修改成功',
      deleteConfirm: '确定要删除该科目对应吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
    },
  },
}
